import Repository from './Repository';
import {AxiosResponse} from "axios";
import { CautionaryProductTypeOptions } from '@/models/Cautionary/CautionaryProductTypeOptions';
import { MethodResult } from './ResultTypes/MethodResult';
import {LabelLanguage} from "@/models/NutritionLabels/LabelLanguage";
import {CaffeinatedProductType} from "@/models/Cautionary/CaffeinatedProductType";
import {CautionaryFoodType} from "@/models/Cautionary/CautionaryFoodType";

const resource = '/cautionary';

export default {
  getCautionaryProductTypes(): Promise<AxiosResponse<CautionaryProductTypeOptions>> {
    return Repository.get<CautionaryProductTypeOptions>(
      `${resource}/GetCautionaryProductTypes`,
      { withCredentials: true }
    );
  },
  getCautionaryLabelImage(
    recipeId: number,
    width: number,
    labelLanguage: LabelLanguage,
    caffeinatedProductType: CaffeinatedProductType,
    cautionaryFoodType: CautionaryFoodType,
    servingsPerContainer: number
  ): Promise<AxiosResponse<Blob>> {
    return Repository.get<Blob>(
      (`${resource}/GetCautionaryLabelImage/${recipeId}?maxWidth=${width}&labelLanguage=${labelLanguage}`
        + `&caffeinatedProductType=${caffeinatedProductType}&cautionaryFoodType=${cautionaryFoodType}&servingsPerContainer=${servingsPerContainer}`
      ),
      { withCredentials: true, responseType: 'blob' }
    );
  },
  previewCautionaryFOPLabel(data: {
  recipeId: number;
  labelFormatValue: number;
  pdsSizeValue: number;
  labelType: number;
}): Promise<AxiosResponse<MethodResult<{ id: number; content: string }>>> {
    return Repository.post(
      `${resource}/previewCautionaryFrontOfPackageLabel`,
      data,
      { withCredentials: true }
    );
  }
};
